export default "__VITE_ASSET__BNM5LH$f__"